import { render, staticRenderFns } from "./SettingsQuestion.vue?vue&type=template&id=b28d83be&scoped=true"
import script from "./SettingsQuestion.vue?vue&type=script&lang=js"
export * from "./SettingsQuestion.vue?vue&type=script&lang=js"
import style0 from "./SettingsQuestion.vue?vue&type=style&index=0&id=b28d83be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28d83be",
  null
  
)

export default component.exports